import { Link } from "react-router-dom";
import "./cardcustom.css";
const CardCustom = ({ spectacle, url }) => {
	return (
		<Link to={url} reloadDocument >
			<div
				className="card text-white card-has-bg click-col"
				style={{
					backgroundImage: `url("${spectacle.affiche}")`,
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
				}}
			>
				<div className="card-img-overlay">
					<div className="card-body">
						<h3 className="card-title">{spectacle.titre}</h3>
						{spectacle.mini_description && (
							<p className="card-description">{spectacle.mini_description}</p>
						)}
					</div>
				</div>
			</div>
		</Link>
	);
};

export default CardCustom;
